import React from 'react';
import { Button, CircularProgress, Grid, InputLabel, TextField, Typography } from '@material-ui/core';
import Alert from '../../../common/components/Alert';
import { useTranslation } from 'react-i18next';
import { AuthPageStyles } from '../../styles';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { ForgotPasswordFormProps } from '../ForgotPasswordForm';
import { genericJourneyTheme } from '../../../common/styles/genericJourneyTheme';
import { useAppSelector } from '../../../redux-store/hook';

const CommonForgotPasswordLayout = ({
  value,
  placeholderKey,
  helperText,
  labelKey,
  cancelRoutePath,
  locked,
  inputChangeHandler,
  onResetPasswordClick,
  alert,
  loading,
  isJourneyLayout = false,
}: ForgotPasswordFormProps): JSX.Element => {
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const classes = AuthPageStyles({ isICPEnabled: isICPEnabled });
  const genericJourneyClass = genericJourneyTheme();
  const { t } = useTranslation();
  return (
    <>
      <Grid container spacing={4} className={`${isJourneyLayout ? genericJourneyClass.marginBottom0 : ''}`}>
        <Grid item xs={12}>
          <Typography variant="h2">{t(locked ? 'accountLocked' : 'resetPassword')}</Typography>
        </Grid>

        <Grid item xs={12}>
          {/** input field with label */}
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <InputLabel htmlFor={labelKey}>
                <b>{t(labelKey)}</b>
              </InputLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id={labelKey}
                variant="outlined"
                required
                fullWidth
                name={labelKey}
                autoComplete={labelKey}
                autoFocus={true}
                size="small"
                type={labelKey === 'email' ? 'email' : 'text'}
                value={value}
                error={helperText !== ''}
                helperText={helperText !== '' ? t(helperText) : undefined}
                placeholder={t(placeholderKey)}
                onChange={inputChangeHandler(labelKey)}
                onBlur={inputChangeHandler(labelKey)}
                inputProps={{
                  'aria-label': labelKey,
                  maxLength: '100',
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        {/** alert message to show reset password api success or fails */}
        <div className={classes.htmlLinks}>
          <Alert state={alert.state} show={alert.message !== ''}>
            {ReactHtmlParser(alert.message)}
          </Alert>
        </div>

        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <Grid item>
              {/** button for cancel */}
              <Button
                type="submit"
                variant="outlined"
                color="secondary"
                component={Link}
                aria-label={t('cancel')}
                to={{
                  pathname: cancelRoutePath,
                  state: { signInTab: 1 },
                }}>
                <div>{t('cancel')}</div>
              </Button>
            </Grid>
            <Grid item>
              {/** button for reset password */}
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                disabled={loading || value === '' || helperText !== ''}
                aria-hidden={loading || value === '' || helperText !== ''}
                aria-disabled="false"
                aria-label={t('resetMyPassword')}
                onClick={onResetPasswordClick}>
                <div>{t('resetMyPassword')}</div>
                {loading && <CircularProgress size={25} className={classes.buttonProgress} />}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default CommonForgotPasswordLayout;
